module.exports = __webpack_public_path__ + "name=img/src/assets/story/7.jpg?bafb1a894da05cd7d257a1a04985b489";